export { getWelcomeEmailTemplate } from './welcomeEmail';
export { getInvitationEmailTemplate } from './invitationEmail';
export { getPasswordResetEmailTemplate } from './passwordResetEmail';

export const emailTemplates = {
  passwordChanged: (email: string) => ({
    subject: 'Password Changed - FeedbackFlow',
    html: `
      <h1>Password Changed</h1>
      <p>Your password for FeedbackFlow account (${email}) has been changed.</p>
      <p>If you did not make this change, please contact support immediately at support@feedbackflow.com</p>
    `,
  }),
};